import { useSyncExternalStore } from "react";
import { getFilingClosure, subscribeFilingAvailability } from "../utils/filingAvailability";

export default function useFilingClosure() {
  return useSyncExternalStore(subscribeFilingAvailability, getFilingClosure, () => null);
}
